<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useFocusConversationQueue } from 'dashboard/composables/useFocusConversationQueue';

const { t } = useI18n();
const {
  isListHidden,
  canNavigate,
  nextName,
  nextPosition,
  total,
  goNext,
  skipForNow,
} = useFocusConversationQueue();

const hint = computed(() => {
  if (!canNavigate.value) {
    return t('CHAT_LIST.FOCUS_QUEUE.HINT_LAST');
  }
  return t('CHAT_LIST.FOCUS_QUEUE.HINT', {
    name: nextName.value,
    current: nextPosition.value,
    total: total.value,
  });
});
</script>

<template>
  <div
    v-show="isListHidden"
    class="flex flex-wrap items-center gap-2 px-5 pb-3 pt-1"
    data-testid="focus-queue-footer"
  >
    <button
      type="button"
      class="inline-flex h-[38px] items-center rounded-full bg-n-blue-9 px-4 text-[13.5px] font-bold text-white hover:bg-n-blue-10 disabled:cursor-not-allowed disabled:opacity-40"
      data-testid="focus-queue-next"
      :disabled="!canNavigate"
      @click="goNext"
    >
      {{ t('CHAT_LIST.FOCUS_QUEUE.NEXT') }}
    </button>
    <button
      type="button"
      class="inline-flex h-[38px] items-center rounded-full px-4 text-[13.5px] font-bold text-n-slate-12 hover:bg-n-alpha-2 disabled:cursor-not-allowed disabled:opacity-40"
      data-testid="focus-queue-skip"
      :disabled="!canNavigate"
      @click="skipForNow"
    >
      {{ t('CHAT_LIST.FOCUS_QUEUE.SKIP') }}
    </button>
    <span class="ml-auto hidden text-xs text-n-slate-11 md:inline">
      {{ hint }}
    </span>
  </div>
</template>
